<template>
  <div
    v-if="ui.isLoading"
    class="is-loading Section Content"
  />
  <div v-else>
    <nav id="sub">
      <div
        :class="['subnav-txt col-4-3']"
      >
        <h1>
          {{ event.name }}
        </h1>
        <p>Create and manage your Events</p>
      </div>
    </nav>
    <router-view v-if="event.id" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      ui: {
        isLoading: false,
      },
    };
  },
  computed: {
    ...mapState('events', {
      event: (state) => state.event,
    }),
  },
  mounted() {
    if (this.$route.params.eventId !== 'undefined') {
      this.ui.isLoading = true;
      this.getEvent(this.$route.params.eventId)
        .then(() => {
          this.ui.isLoading = false;
        })
        .catch(({ data }) => {
          this.ui.isLoading = false;
          this.$bus.$emit('displayMsg', {
            text: data.data.message,
            type: 'warning',
          });
        });
    }
  },
  methods: {
    ...mapActions('events', ['getEvent']),
  },

};
</script>

<style lang="less" scoped>
.Section {
  border: none;
}
.Content {
  height: 80vh;
}
</style>
